import { render } from "./IzinSiswa.vue?vue&type=template&id=fd2d0700&scoped=true"
import script from "./IzinSiswa.vue?vue&type=script&lang=js"
export * from "./IzinSiswa.vue?vue&type=script&lang=js"

import "./IzinSiswa.vue?vue&type=style&index=0&id=fd2d0700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2d0700"]])

export default __exports__